/**
 * @desc 获取支付渠道类型枚举
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/getPaymentChannelTypeEnum',
    params,
    method: 'get',
  })
}
